import React from "react";

export default function Ticket() {
  return (
    <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_1283_16762)">
        <g clip-path="url(#clip0_1283_16762)">
          <rect x="1" width="40" height="40" rx="12" fill="url(#paint0_linear_1283_16762)" />
          <g clip-path="url(#clip1_1283_16762)" filter="url(#filter1_dd_1283_16762)">
            <path d="M27.9958 16.5022L21.0009 9.50734C20.5371 9.04355 19.908 8.78299 19.2521 8.78299C18.5962 8.78299 17.9672 9.04355 17.5034 9.50734L15.1718 11.839L15.7547 12.4219C16.0639 12.7311 16.2376 13.1504 16.2376 13.5877C16.2376 14.025 16.0639 14.4443 15.7547 14.7535C15.4455 15.0627 15.0261 15.2364 14.5889 15.2364C14.1516 15.2364 13.7322 15.0627 13.423 14.7535L12.8401 14.1706L10.5085 16.5022C10.0447 16.966 9.78415 17.5951 9.78415 18.251C9.78415 18.9069 10.0447 19.5359 10.5085 19.9997L17.5034 26.9946L19.835 24.663L21.0009 25.8288L18.6692 28.1604L22.7496 32.2408L26.8299 28.1604L26.247 27.5775C25.9378 27.2683 25.7641 26.849 25.7641 26.4117C25.7641 25.9744 25.9378 25.5551 26.247 25.2459C26.5562 24.9367 26.9756 24.763 27.4129 24.763C27.8501 24.763 28.2695 24.9367 28.5787 25.2459L29.1616 25.8288L33.242 21.7484L29.1616 17.6681L26.8299 19.9997L25.6641 18.8339L27.9958 16.5022ZM25.0812 21.7484L22.7496 24.0801L21.5838 22.9142L23.9154 20.5826L25.0812 21.7484Z" fill="url(#paint1_linear_1283_16762)" />
          </g>
        </g>
      </g>
      <defs>
        <filter id="filter0_di_1283_16762" x="0.5" y="0" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1283_16762" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1283_16762" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1283_16762" />
        </filter>
        <filter id="filter1_dd_1283_16762" x="-21" y="-18.1015" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1283_16762" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3.89851" />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_1283_16762" result="effect2_dropShadow_1283_16762" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1283_16762" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_1283_16762" x1="21" y1="0" x2="21" y2="40" gradientUnits="userSpaceOnUse">
          <stop stop-color="#29282C" />
          <stop offset="1" stop-color="#100F11" />
        </linearGradient>
        <linearGradient id="paint1_linear_1283_16762" x1="5.80425" y1="15.4576" x2="28.5994" y2="16.536" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0.65" />
        </linearGradient>
        <clipPath id="clip0_1283_16762">
          <rect x="1" width="40" height="40" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_1283_16762">
          <rect width="24" height="24" fill="white" transform="translate(9 8)" />
        </clipPath>
      </defs>
    </svg>

  )
}